<template>
      <div class="flex-1 w-full lg:w-1/2 px-4 py-4">
        <h1 slot="header" class="w-full text-lg mb-4">
          Profile Picture:
        </h1>
        <h2 class="text-grey-dark text-sm font-medium leading-normal pb-4">
          This image will be used on the website and all relevant printed material.
        </h2>
        <div class="flex flex-col">
            <div class="flex flex-row w-full h-1/2 border-grey-lighter">
              <div class="w-2/5 object-fill mb-4">
              <img v-if="profile.userApproval.uploaded_photo && system.external_data.bios === true && system.external_data.reduced_bios === false" :src="profile.userApproval.uploaded_photo" alt="" class="object-contain h-full w-full">
              <img v-else-if="profile.uploaded_photo && system.external_data.bios === true && system.external_data.reduced_bios === true" :src="profile.uploaded_photo" alt="" class="object-contain h-full w-full">
              <img v-else-if="profile.uploaded_photo && system.external_data.bios === false && system.external_data.reduced_bios === false" :src="profile.uploaded_photo" alt="" class="object-contain h-full w-full">
              <div v-else class="flex border-dotted border-2 items-center h-80 w-full" @click="showImageModal = true">
                <img :src="require('@/assets/images/avatar.png')" alt="" class="object-contain h-full w-full">
              </div>
              </div>

              <div class="w-3/5 px-2 mb-4">
                  <div class="flex mb-6" v-if="system.networks.length >= 1 && (system.networks[0].id === 7 || system.networks[0].id === 8 || system.networks[0].id === 118)"><icon name="camera_new" class="h-6 w-6 mr-2 text-blue" :center="false"></icon>
                    <a href="https://sites.google.com/ewemove.com/lambingplan/step-1?authuser=0#h.gafbt6efujh9" target="_blank" class="mt-1" v-if="system.networks[0].id === 118">Photo Guide & Requirements</a>
                    <a href="https://my.corebook.io/fineandcountry/personal-presentation/professional-portrait" target="_blank" class="mt-1" v-else>Photo Guide & Requirements</a>
                  </div>
                  <div class="text-blue flex cursor-pointer mb-4" :class="{'opacity-25': value.userApproval.status === 0}">
                      <icon name="upload" class="h-6 w-6 mr-2" :center="false"></icon><button @click="showImageModal = true" :disabled="value.userApproval.status === 0" class="mt-1 text-blue">Upload a new image</button>
                  </div>
                  <div  v-if="!profile.userApproval.uploaded_video && system.external_data.bios === true" class="flex text-blue cursor-pointer" :class="{'opacity-25': value.userApproval.status === 0}"  >
                    <icon name="video2" class="h-6 w-6 mr-2" :center="false"></icon><button @click="showProfileVideoTog()" :disabled="value.userApproval.status === 0" class="mr-2 mt-1 text-blue"> Add Profile Video.</button>
                    <i v-if="!showProfileVideo" class="fas fa-plus text-grey mt-1"></i>
                    <i v-else class="fas fa-minus text-grey mt-1"></i>
                  </div>
              </div>
            </div>
            <div v-if="system.external_data.bios === true">
              <div class="flex flex-row h-1/2 object-fit w-full" v-if="profile.userApproval.uploaded_video || showProfileVideo">
                  <div class="w-2/5">
                      <video v-if="profile.userApproval.uploaded_video" class=" w-full h-full" controls>
                          <source :src="profile.userApproval.uploaded_video" type="video/mp4">
                      </video>
                      <div v-else class="flex border-dotted border-2 w-full h-full items-center" @click="showVideoModal = true">
                          <p class="text-center w-full" > click Upload a Video</p>
                      </div>
                  </div>
                  <div class="w-3/5">
                    <div class="flex mb-6"><icon name="video2" class="h-8 w-8 ml-2 mr-2 text-blue" :center="false"></icon><a  href="https://my.corebook.io/fineandcountry/personal-presentation/personal-video" target="_blank" class="mt-2">Video Guide & Requirements</a></div>
                    <div class="text-blue flex mb-6 cursor-pointer" :class="{'opacity-25': value.userApproval.status === 0}">
                      <icon name="upload" class="h-6 w-6 ml-2 mr-2" :center="false"></icon><button @click="showVideoModal = true" :disabled="value.userApproval.status === 0" class="mt-1 text-blue">Upload a new video</button>
                    </div>
                    <div v-if="profile.userApproval.uploaded_video" class="text-blue flex cursor-pointer" :class="{'opacity-25': value.userApproval.status === 0}">
                      <icon name="bin2" class="h-6 w-6 ml-2 mr-2" :center="false"></icon><button :disabled="value.userApproval.status === 0" @click="removedVideoModal = true" class="mt-1 text-blue">Remove video</button>
                    </div>
                  </div>
              </div>
            </div>
         </div>
        <modal v-if="showVideoModal" :showCloseBtn="true" @leave="showVideoModal = null">
          <div class="flex">
            <div
              class="relative flex flex-col items-center w-1/2 justify-center border border-grey rounded border-dashed mb-4 cursor-pointer"
              :class="{ 'h-70': !file }"
            >
                <input
                v-show="!file"
                type="file"
                class="input-file absolute pin-t pin-l h-full w-full opacity-0 cursor-pointer"
                @change="loadVideo"
                ref="videoFile"
                accept="video/mp4"
                />
                <button
                v-if="!file"
                class="bg-tertiary font-bold px-3 rounded mt-2 chooseFileButton inline-flex items-center justify-center w-48 mb-5"
                >
                <icon
                    name="videoettes"
                    class="w-10 mr-3 text-white ico"
                    :center="false"
                />
                <span class="text-sm font-thin text-primary text-white text-center">Choose file</span>
                </button>
                <p
                v-if="!file"
                class="call-to-action text-sm font-thin text-center py-4"
                >
                Click or drag and drop
                <br />your video here
                </p>
                <p v-if="file" class="call-to-action text-sm font-thin text-center py-4">{{fileName}}</p>
                <button :disabled="uploadingVideo"
                v-if="file"
                class=" bg-tertiary text-white text-base p-2 rounded mb-2 cursor-pointer z-50"
                @click.prevent="removeFile"
                :class="{'opacity-25': uploadingVideo}"
                >
                Remove File
                </button>
            </div>
            <div class="flex flex-col items-center w-1/2 h-full">
                <div>
                    <loader v-if="uploadingVideo"/>
                    <button v-else class="bg-tertiary text-white text-base p-2 rounded mb-2 center" :disabled="!file" @click="uploadVideo" :class="{'opacity-25': !file}" >Save Video</button>
                </div>

            </div>
          </div>
        </modal>
        <modal v-if="showImageModal" :showCloseBtn="true" @leave="modalLeave()">
            <div class="flex flex-row">
                <div class="flex flex-row relative">
                    <vue-avatar class="border-dotted border-2"
                    :width="300"
                    :height="350"
                    :border="0"
                    :scale="scale"
                    ref="vueavatar"
                    :image="null"
                    v-model='scale'
                    @vue-avatar-editor:image-ready="onImageReady"
                    @vue-avatar-editor:file-size="checkFile"
                    @vue-avatar-editor:file-type="checkFileType"
                    style="height:350px; width:300px">
                    </vue-avatar>
                    <div class="bottom-0 left-0">
                        <div class="image-button flex flex-col">
                            <button class="px-2 text-black text-xl bg-white border" @click="addScale">+</button>
                            <button class="px-2 text-black text-xl bg-white border" @click="removeScale">-</button>
                        </div>
                    </div>
                </div>
            <div class="flex flex-col items-center ml-4">
                <div class="p-2"><span class="italic">'Drag & Drop'</span> onto the image.</div>
                <div class="p-2 text-xs">Minimum size allowed is 2mb - PNG or JPEG</div>
                <div class="p-2 mb-2">Position your picture within the frame to you preferred composition.</div>
                <div class="p-2 mb-1 text-red " v-if="fileType">File type not supported, please use a JPEG or PNG</div>
                <div class="p-2 text-red mb-2" v-if="fileToBig">File size too small</div>

                <div class="text-xs">
                    <loader v-if="uploadingProfilePhoto"/>
                    <button v-else class="bg-black text-white text-base p-2 rounded mb-2" :disabled="saveImageButton" :class="{'opacity-25': saveImageButton}" @click="uploadPhoto" >Save image</button>
                </div>
            </div>
            </div>
        </modal>
        <modal
          v-if="removedVideoModal"
          :scrollY="false"
          @dismissed="removedVideoModal = false"
          @leave="removedVideoModal = false"
          :showCloseBtn="true"
          :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/2'"
        >
          <div class="flex h-full flex-col items-center">
            <div class="p-2 mb-4">
              <p class="text-center text-lg">Are you sure you want remove the video?</p>
            </div>
            <div class="flex items-center">
              <button  @click="removeVideo" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
                Yes
              </button>
              <button  @click="removedVideoModal = false" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
                no
              </button>
            </div>
          </div>
        </modal>
      </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import api from '@/http'
import VueAvatar from './VueAvatar.vue'
import Icon from '../Icon.vue'
import http from 'axios'
export default {
  name: 'profileImage',
  components: {
    VueAvatar,
    Icon
  },
  props: ['value'],
  data () {
    return {
      showImageModal: false,
      scale: 1,
      fileToBig: false,
      fileType: false,
      uploadingProfilePhoto: false,
      uploadingVideo: false,
      showProfileVideo: false,
      showVideoModal: false,
      file: '',
      fileName: null,
      profile: this.value,
      removedVideoModal: false,
      saveImageButton: true
    }
  },
  computed: {
    ...mapState([
      'system', 'selectedOffice', 'profile_v2'
    ])
  },
  methods: {
    ...mapActions([
      'fetchProfileV2'
    ]),
    addScale () {
      if (this.scale >= 3) {
        return
      }
      this.scale = this.scale + 0.1
    },
    removeScale () {
      if (this.scale <= 1) {
        return
      }
      this.scale = this.scale - 0.1
    },
    checkFile (e) {
      this.fileToBig = false
      if (e < 2097152) {
        this.fileToBig = true
      }
    },
    checkFileType (type) {
      if (!['image/png', 'image/jpeg', 'image/jpg'].includes(type)) {
        this.fileType = true
      }
    },
    uploadPhoto (e) {
      let data = new FormData()
      data.append('_method', 'PATCH')
      var img = this.$refs.vueavatar.getImage()
      data.append('uploaded_photo', img.toDataURL())
      data.append('selectedOffice', this.selectedOffice.id)
      this.uploadingProfilePhoto = true
      api.post('upload-photo/' + this.profile.id, data).then(response => {
        this.uploadingProfilePhoto = false
        this.$emit('mediaupdate')
        this.profile = response.data
        this.showImageModal = false
      })
    },
    async uploadVideo () {
      let filePath = 'user/' + this.profile.id
      const extension = this.fileName.split('.').pop()
      const response = await api.post('signed-upload', {
        'disk': 's3',
        'extension': extension,
        'path': filePath,
        'visibility': 'public-read'
      })

      let s3File = response.data.key
      let headers = response.data.headers
      if ('Host' in headers) {
        delete headers.Host
      }
      this.uploadingVideo = true
      await http.put(response.data.url, this.file, {
        headers: headers
      })
      this.profile.userApproval.uploaded_video = null
      api.post('upload-video/' + this.profile.id, {
        filePath: s3File,
        extension: extension,
        selectedOffice: this.selectedOffice.id
      })
        .then((response) => {
          this.uploadingVideo = false
          this.profile = response.data
          this.$emit('mediaupdate')
          this.showVideoModal = false
          this.removeFile()
        })
    },
    removeVideo () {
      this.profile.userApproval.uploaded_video = null
      let params = {
        selectedOffice: this.selectedOffice.id
      }
      api.post('remove-video/' + this.profile.id, params).then(response => {
        this.profile = response.data
        this.$emit('mediaupdate')
        this.removedVideoModal = false
      })
    },
    showProfileVideoTog () {
      if (this.showProfileVideo === true) {
        this.showProfileVideo = false
        return
      }
      if (this.showProfileVideo === false) {
        this.showProfileVideo = true
      }
    },
    loadVideo () {
      this.file = this.$refs.videoFile.files[0]
      this.fileName = this.file.name
    },
    removeFile () {
      this.file = ''
    },
    onImageReady () {
      // do nothing for now
      this.saveImageButton = false
    },
    modalLeave () {
      this.showImageModal = false
      this.saveImageButton = true
    }
  }
}
</script>
